import { render, staticRenderFns } from "./OdPortalTarget.vue?vue&type=template&id=032cc114&"
import script from "./OdPortalTarget.vue?vue&type=script&lang=js&"
export * from "./OdPortalTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032cc114')) {
      api.createRecord('032cc114', component.options)
    } else {
      api.reload('032cc114', component.options)
    }
    module.hot.accept("./OdPortalTarget.vue?vue&type=template&id=032cc114&", function () {
      api.rerender('032cc114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/OdPortalTarget.vue"
export default component.exports